import { render, staticRenderFns } from "./apprTodo.vue?vue&type=template&id=0724cc96"
import script from "./apprTodo.vue?vue&type=script&lang=js"
export * from "./apprTodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0724cc96')) {
      api.createRecord('0724cc96', component.options)
    } else {
      api.reload('0724cc96', component.options)
    }
    module.hot.accept("./apprTodo.vue?vue&type=template&id=0724cc96", function () {
      api.rerender('0724cc96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/appr/doc/apprTodo.vue"
export default component.exports